import React from "react";
import { Container, Col, Row, Table } from "react-bootstrap";
import Header from "../stories/components/Header.js";
import Image from "../stories/components/Image.js";
import TypoTableHead from "../stories/components/TypoTableHead";
import TypoTableRow from "../stories/components/TypoTableRow";

import OpenSansImage from "../assets/Open-sans.png";
import OpenSansKursivImage from "../assets/Open-sans-kursiv.png";
import OpenSansTegnImage from "../assets/Open-sans-tegn.png";
import CalibriImage from "../assets/Calibri.png";

export default function TypographyPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Typografi"
          lead="Open Sans er statsforvalterens profilfont for digital og trykte medier."
        />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Open Sans</h2>
              <p>
                Open Sans er en gratis font tilgjengelig fra Google for Mac og
                PC og finnes i mange snitt. Den finnes både for print og web.
              </p>
              <p>
                Open Sans Regular er hovedvekten som skal brukes på overskrifter
                og brødtekst, men man kan kombinere med andre vekter av fonten
                for å kommunisere tydelig.
              </p>
              <p>
                Fonten skal i hovedsak brukes på alt materiell produsert fra
                Statsforvalteren.
              </p>
              <p>
                For uformelle publikasjoner med standardlogo brukes Open Sans i
                alle snitt også for Microsoft Office (PowerPoint, Word osv.). I
                tilfeller Open Sans ikke er installert kan fonten Calibri
                brukes.
              </p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={OpenSansImage}
            alt="Open Sans"
            caption="Open Sans"
          />
          <Image
            size="medium"
            imgUrl={OpenSansKursivImage}
            alt="Open Sans kursiv"
            caption="Open Sans kursiv"
          />
          <Image
            size="medium"
            imgUrl={OpenSansTegnImage}
            alt="Alle tilgjengelige tegn og symboler"
            caption="Fordelen med Open Sans er at den har mange spesialtegn og dekker
            mange språk."
          />
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h3 className="mt-4">Calibri som alternativ</h3>
              <p>
                statsforvalterens erstatningsfont, Calibri, skal kun brukes i de
                tilfeller der mottaker ikke har adgang/installert profilfonten,
                Open Sans.
              </p>
              <p>Eksempel på flater der standardfonten kan benyttes:</p>
              <ul>
                <li>PPT</li>
                <li>Nyhetsbrev</li>
                <li>Word-dokument</li>
              </ul>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={CalibriImage}
            alt="Calibri"
            caption="Calibri"
          />

          <Row className="my-6">
            <Col lg={{ span: 8, offset: 2 }}>
              <h2>Typografi for web</h2>
              <Table responsive size="lg" className="table-simple">
                <TypoTableHead />
                <tbody>
                  <TypoTableRow
                    tag={<h1>H1</h1>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="36px"
                    desktop="52px"
                  />
                  <TypoTableRow
                    tag={<h2>H2</h2>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="28px"
                    desktop="32px"
                  />
                  <TypoTableRow
                    tag={<h3>H3</h3>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="22px"
                    desktop="24px"
                  />
                  <TypoTableRow
                    tag={<h4>H4</h4>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="18px"
                    desktop="20px"
                  />
                  <TypoTableRow
                    tag={<h5>H5</h5>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="16px"
                    desktop="16px"
                  />
                  <TypoTableRow
                    tag={<h6>H6</h6>}
                    fontWeight="Bold"
                    lineHeight="1.2"
                    mobile="14px"
                    desktop="14px"
                  />
                  <TypoTableRow
                    tag={<p className="lead">Ingress</p>}
                    fontWeight="Regular"
                    lineHeight="1.5"
                    mobile="20px"
                    desktop="24px"
                  />
                  <TypoTableRow
                    tag={<p>Brødtekst</p>}
                    fontWeight="Regular"
                    lineHeight="1.5"
                    mobile="16px"
                    desktop="16px"
                  />
                  <TypoTableRow
                    tag={<div className="small">Liten tekst</div>}
                    fontWeight="Regular"
                    lineHeight="-"
                    mobile="14px"
                    desktop="14px"
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
